module.exports = __webpack_public_path__ + "img/img_11.5d3c9cf8.png";